export enum ActionConstants {
  CHANGE_PAGE = 'CHANGE_PAGE',
  CHANGE_TAB = 'CHANGE_TAB',
  SELECT_PACKAGE = 'SELECT_PACKAGE',
  ON_DISMISS_MODAL = 'NEW_ENTITY_MODAL/ON_DISMISS_MODAL',
  ON_FETCH_GITHUB_URL = 'ON_FETCH_GITHUB_URL',
}
